<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="项目">
              <a-select
                allowClear
                showSearch
                optionFilterProp="children"
                placeholder="请选择项目"
                v-model="searchModel.projectId"
              >
                <a-select-option v-for="(item, index) in projectList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="合同编号">
              <a-input placeholder="请输入合同编号" v-model="searchModel.number" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="合同名称">
              <a-input placeholder="请输入合同名称" v-model="searchModel.name" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="true" v-show="showExpend">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" v-if="true" v-show="showExpend" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'MarketsSearchForm',
  mounted () {},
  computed: {
    projectList () {
      return this.$store.state.contract.projectList
    }
  },
  data () {
    return {
      showExpend: false,

      searchModel: {},
      advanced: false // 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表
  }
}
</script>

<style scoped>
</style>
